import { render, staticRenderFns } from "./EditAnnotationControl.vue?vue&type=template&id=0ffa1c82"
import script from "./EditAnnotationControl.vue?vue&type=script&lang=js"
export * from "./EditAnnotationControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports